import type { ExtraArgument } from '@castlery/shared-redux-extra';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { adminLogin, getCurrentAdmin, noticeCityInfoUpdated } from '@castlery/modules-user-domain';
import { getRetailById } from '@castlery/modules-retails-domain';
import { createPosOrderForCurrentAdmin } from '@castlery/modules-order-services';
import { enableBranch } from '@castlery/config';
import { makePersistenceHandles } from '@castlery/shared-persistence-kit';

export const salesRepLogin = createAsyncThunk(
  'user/salesRepLogin',
  async (
    {
      username,
      password,
      retailId,
      autoCreateAOrder = true,
    }: { username: string; password: string; retailId: number | string; autoCreateAOrder?: boolean },
    { dispatch, rejectWithValue, extra }
  ) => {
    const { persistenceHandles } = extra as ExtraArgument;
    const pre_access_token = (await persistenceHandles.accessToken.getItem()) || '';
    const pre_refresh_token = (await persistenceHandles.refreshToken.getItem()) || '';
    try {
      await dispatch(adminLogin({ username, password })).unwrap();
      let retailInfo;
      if (enableBranch) {
        retailInfo = await dispatch(getRetailById.initiate(retailId)).unwrap();
      }
      const userInfo = await dispatch(
        getCurrentAdmin.initiate(undefined, {
          forceRefetch: true,
        })
      ).unwrap();
      persistenceHandles.retailId.setItem(retailId + '');

      // 创建订单
      if (autoCreateAOrder) {
        await dispatch(createPosOrderForCurrentAdmin({}));
      }
      if (enableBranch) {
        return { userInfo, retailInfo };
      }
      return { userInfo };
    } catch (error) {
      await persistenceHandles.accessToken.setItem(pre_access_token);
      await persistenceHandles.refreshToken.setItem(pre_refresh_token);
      return rejectWithValue(error);
    }
  }
);

export const resetUserLocation = createAsyncThunk(
  'user/resetUserLocation',
  async (
    payload: {
      state: string;
      city: string;
      zipcode: string;
    },
    { dispatch }
  ) => {
    await makePersistenceHandles()?.city?.setItem(JSON.stringify(payload));
    await dispatch(noticeCityInfoUpdated(payload));
    return Promise.resolve();
  }
);
